import React from 'react'

export default function HandRaise({ className }) {
    return (
        <svg
            className={`${className} w-8 h-8`}
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M9 12.5V5.5a1.5 1.5 0 0 1 3 0V11"
                stroke="#CA8A04"
                strokeWidth="1.6"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M12 11V3.5a1.5 1.5 0 0 1 3 0V11"
                stroke="#CA8A04"
                strokeWidth="1.6"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M15 11V5.5a1.5 1.5 0 0 1 3 0V14"
                stroke="#CA8A04"
                strokeWidth="1.6"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M6 13.5V10a1.5 1.5 0 0 1 3 0v3.5"
                stroke="#CA8A04"
                strokeWidth="1.6"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M6 13.5c0 4.694 3.134 8 7 8s6-3.5 6-7.5V9"
                fill="#FEF3C7"
                stroke="#CA8A04"
                strokeWidth="1.6"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    )
}
